import React from 'react';
import {makeStyles} from '@material-ui/core/styles'


const useStyles=makeStyles((themes)=>({

    svg:{
        width:"50%",
        [themes.breakpoints.down('xs')]: {
            width:"100%"
          },
      
    }
    }));

export default function Path3(){
    const classes =useStyles();

    return(
        
        <div>
                        <svg xmlns="http://www.w3.org/2000/svg" className={classes.svg}  viewBox="0 0 635.4 222.8">
            <g id="_3" data-name="3" transform="translate(-164.6)">
                <g id="Layer_1">
                <g id="Group_11" data-name="Group 11">
                    <circle id="Ellipse_1" cx="10.1" cy="10.1" r="10.1" transform="translate(779.8 0)" fill="#3c71a5"/>
                    <circle id="Ellipse_2" cx="7.8" cy="7.8" r="7.8" transform="translate(782.1 2.3)" fill="#fff"/>
                </g>
                <rect id="Rectangle_1_1_" width="2.1" height="35.1" transform="translate(788.9 20.1)" fill="#3c71a5"/>
                </g>
                <g id="laptop">
                <g id="Group_14" data-name="Group 14">
                    <g id="Group_13" data-name="Group 13">
                    <path id="Path_19" data-name="Path 19" d="M419,145.6v-7.4h-2.7v6a1.752,1.752,0,0,1-1.7,1.7H380.8a1.752,1.752,0,0,1-1.7-1.7V123.9a1.752,1.752,0,0,1,1.7-1.7h19.4v-1.7H378.4a1.9,1.9,0,0,0-1.9,1.9v25.1l-4.8,5.8a2.9,2.9,0,0,0,2.9,2.9h46.6a2.9,2.9,0,0,0,2.9-2.9l-4.8-5.8-.3-1.9Zm-17.5,9.7h-7.8a.5.5,0,1,1,0-1h7.8a.5.5,0,0,1,0,1Zm-11.9-1.9,1.5-1.8h13l1.5,1.8Z" fill="#3b6fa5"/>
                    <g id="Group_12" data-name="Group 12">
                        <rect id="Rectangle_2" data-name="Rectangle 2" width="4.1" height="4" transform="translate(394.4 134.7)" fill="#3b6fa5"/>
                        <rect id="Rectangle_3" data-name="Rectangle 3" width="4" height="4.1" transform="translate(397 129.2)" fill="#3b6fa5"/>
                        <rect id="Rectangle_4" data-name="Rectangle 4" width="4" height="4" transform="translate(401 134.2)" fill="#3b6fa5"/>
                        <rect id="Rectangle_5" data-name="Rectangle 5" width="4.8" height="4.8" transform="translate(404.2 127.5)" fill="#3b6fa5"/>
                        <rect id="Rectangle_6" data-name="Rectangle 6" width="4.8" height="4.8" transform="translate(411 112.8)" fill="#3b6fa5"/>
                        <rect id="Rectangle_7" data-name="Rectangle 7" width="4.8" height="4.8" transform="translate(402.3 121.5)" fill="#3b6fa5"/>
                        <rect id="Rectangle_8" data-name="Rectangle 8" width="6.9" height="6.9" transform="translate(409.8 119.4)" fill="#3b6fa5"/>
                        <rect id="Rectangle_9" data-name="Rectangle 9" width="8.3" height="8.3" transform="translate(414.9 127.7)" fill="#3b6fa5"/>
                        <rect id="Rectangle_10" data-name="Rectangle 10" width="10.3" height="10.3" transform="translate(418.1 112.1)" fill="#3b6fa5"/>
                        <rect id="Rectangle_11" data-name="Rectangle 11" width="4.8" height="4.8" transform="translate(408.6 132.9)" fill="#3b6fa5"/>
                    </g>
                    </g>
                </g>
                </g>
                <g id="curve">
                <circle id="Ellipse_1_2_" cx="10.1" cy="10.1" r="10.1" transform="translate(610.7 202.3)" fill="#3b6fa5"/>
                <circle id="Ellipse_2_2_" cx="7.8" cy="7.8" r="7.8" transform="translate(613 204.6)" fill="#fff"/>
                <rect id="Rectangle_1_7_" width="160.4" height="1.4" transform="translate(446.2 142.5)" fill="#3b6fa5"/>
                <path id="Path_20" data-name="Path 20" d="M620.8,167.3a53.905,53.905,0,0,0-2-10.9c-4-12.9-11.6-13.1-12.6-13.1" fill="none" stroke="silver" strokeMiterlimit="10" strokeWidth="1.4"/>
                <path id="Path_21" data-name="Path 21" d="M616.5,149.8" fill="none" stroke="#00aeef" strokeMiterlimit="10" strokeWidth="1.4"/>
                <rect id="Rectangle_1_6_" width="1.4" height="34.3" transform="translate(620.1 166.8)" fill="#3b6fa5"/>
                <path id="Path_22" data-name="Path 22" d="M620.8,167.3a53.905,53.905,0,0,0-2-10.9c-4-12.9-11.6-13.1-12.6-13.1" fill="none" stroke="#3b6fa5" strokeMiterlimit="10" strokeWidth="1.4"/>
                <circle id="Ellipse_1_1_" cx="10.1" cy="10.1" r="10.1" transform="translate(164.6 202.6)" fill="#3b6fa5"/>
                <circle id="Ellipse_2_1_" cx="7.8" cy="7.8" r="7.8" transform="translate(166.9 204.9)" fill="#fff"/>
                <rect id="Rectangle_1_4_" width="160.4" height="1.4" transform="translate(189 142.8)" fill="#3b6fa5"/>
                <path id="Path_23" data-name="Path 23" d="M174.7,167.6a53.907,53.907,0,0,1,2-10.9c4-12.9,11.6-13.1,12.6-13.1" fill="none" stroke="silver" strokeMiterlimit="10" strokeWidth="1.4"/>
                <path id="Path_24" data-name="Path 24" d="M179,150.1" fill="none" stroke="#00aeef" strokeMiterlimit="10" strokeWidth="1.4"/>
                <rect id="Rectangle_1_3_" width="1.4" height="34.3" transform="translate(174 167.1)" fill="#3b6fa5"/>
                <path id="Path_25" data-name="Path 25" d="M174.7,167.6a53.907,53.907,0,0,1,2-10.9c4-12.9,11.6-13.1,12.6-13.1" fill="none" stroke="#3b6fa5" strokeMiterlimit="10" strokeWidth="1.4"/>
                </g>
                <g id="top">
                <rect id="Rectangle_1" width="358.1" height="1.4" transform="translate(431.8 53.9)" fill="#3b6fa5"/>
                <path id="Path_26" data-name="Path 26" d="M399.9,78.6a27.775,27.775,0,0,1,4.5-10.9c9-12.9,26-13.1,28.2-13.1" fill="none" stroke="silver" strokeMiterlimit="10" strokeWidth="1.4"/>
                <path id="Path_27" data-name="Path 27" d="M409.5,61.2" fill="none" stroke="#00aeef" strokeMiterlimit="10" strokeWidth="1.4"/>
                <rect id="Rectangle_1_2_" width="1.3" height="34.3" transform="translate(399.2 78.2)" fill="#3b6fa5"/>
                <path id="Path_28" data-name="Path 28" d="M399.9,78.6a27.775,27.775,0,0,1,4.5-10.9c9-12.9,26-13.1,28.2-13.1" fill="none" stroke="#3b6fa5" strokeMiterlimit="10" strokeWidth="1.4"/>
                </g>
            </g>
            </svg>

        </div>
    )
}